import { signOut } from 'aws-amplify/auth';

export const handleSignOut = async () => {
  try {
    await signOut();
    const errorLogs = localStorage.getItem('errorLogs');
    localStorage.clear();
    if (errorLogs) localStorage.setItem('errorLogs', errorLogs);
    sessionStorage.clear();
  } catch (error) {
    console.error(error, 'Error is generated while logout');
  }
};
